<template>
    <div class="burst-wrap">
        <header class="burst-header">
            <section class="header-main">
                <h1 v-html="$t('burst.header.h1')"></h1>
                <h3>{{$t('burst.header.h3')}}</h3>
                <div class="clear">
                    <div class="left">
                        <div class="num-title">{{$t('burst.header.four_digit')}}</div>
                        <v-number :value="smallReward"></v-number>
                        <div class="num-footer">USDT</div>
                    </div>
                    <div class="right">
                        <div class="num-title">{{$t('burst.header.seven_digit')}}</div>
                        <v-number :value="bigReward"></v-number>
                        <div class="num-footer">USDT</div>
                    </div>
                </div>
            </section>
            <aside class="nav-wrap">
                <nav @click="alertKey = true">{{$t('burst.header.nav1')}}</nav>
                <nav>{{$t('burst.header.nav2')}}</nav>
                <nav @click="alertRules = true">{{$t('burst.header.nav3')}}</nav>
            </aside>
        </header>
        <main>
            <div class="title">
                {{$t('burst.q1.title')}}
            </div>
            <p class="text-con">{{$t('burst.q1.con')}}</p>
            <div class="table-wrap">
                <div class="table-title">
                    {{$t('burst.q1.table_title')}}
                </div>
                <div class="link-wrap" v-html="$t('burst.q1.link')"></div>
                <el-table
                        :data="blockData"
                        style="width: 100%">
                    <el-table-column
                            prop="time"
                            :label="$t('burst.q1.time')"
                            width="320">
                    </el-table-column>
                    <el-table-column
                            :label="$t('burst.q1.block_num')"
                            width="300">
                        <template slot-scope="scope">
                            <label style="color: #222A55 !important;">{{scope.row.blockNum}}</label>
                        </template>
                    </el-table-column>
                    <el-table-column
                            prop="hash"
                            :label="$t('burst.q1.hash')">
                        <template slot-scope="scope">
                            <span v-html="getHashHtml(scope.row.hash, 4)"></span>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <div class="title">
                {{$t('burst.q2.title')}}
            </div>
            <p class="text-con">{{$t('burst.q2.con')}}</p>
            <div class="btn-wrap">
                <router-link to="/ctc">
                    <span class="btn">
                    {{$t('burst.q2.trade_now')}}
                </span>
                </router-link>
            </div>
            <div class="title">
                {{$t('burst.q3.title')}}
            </div>
            <p class="text-con">{{$t('burst.q3.con')}}</p>
            <div class="table-wrap">
                <div class="table-tab-wrap">
                    <span class="tab" :class="{'choice': showTable === 0}" @click="showTable=0">{{$t('burst.q3.table_title1')}}</span>
                    <span v-if="user.username" class="tab" :class="{'choice': showTable === 1}" @click="showTable=1">{{$t('burst.q3.table_title2')}}</span>
                </div>
                <el-table
                        v-show="showTable === 0"
                        :data="awardData"
                        style="width: 100%">
                    <el-table-column
                            :label="$t('burst.q3.time')"
                            width="100">
                        <template slot-scope="scope">
                            {{dateFormatter(new Date(scope.row.eosBlockTime),'yyyy-MM-dd')}}
                        </template>
                    </el-table-column>
                    <el-table-column
                            :label="$t('burst.q3.key')">
                        <template slot-scope="scope">
                            <div style="color: #222A55" v-html="$t('burst.q3.publicKey')+':'+getHashHtml(scope.row.publicKey, 7)"></div>
                            <div v-html="$t('burst.q3.privateKey')+':'+getHashHtml(scope.row.privateKey, 7)"></div>
                        </template>
                    </el-table-column>
                    <el-table-column
                            :label="$t('burst.q3.hash')"
                            width="470">
                        <template slot-scope="scope">
                            <div v-html="getHashHtml(scope.row.eosFirstHashVal, 4)"></div>
                            <div v-html="getHashHtml(scope.row.eosSecondHashVal, 7)"></div>
                        </template>
                    </el-table-column>
                    <el-table-column
                            :label="$t('burst.q3.reward')"
                            width="80">
                        <template slot-scope="scope">
                            <div>{{scope.row.smallRewardHitNumbers}}</div>
                            <div>{{scope.row.bigRewardHitNumbers}}</div>
                        </template>
                    </el-table-column>
                </el-table>
                <el-table
                        v-show="showTable === 1"
                        :data="orderData"
                        style="width: 100%">
                    <el-table-column
                            :label="$t('burst.q3.time')">
                        <template slot-scope="scope">
                            {{dateFormatter(new Date(scope.row.orderTime), 'yyyy-MM-dd hh:mm:ss')}}
                        </template>
                    </el-table-column>
                    <el-table-column
                            prop="orderId"
                            :label="$t('burst.q3.orderNum')">
                    </el-table-column>
                    <el-table-column
                            :label="$t('burst.q3.status')">
                        <template slot-scope="scope">
                            <label v-if="scope.row.rewardStatus === 1" style="color: #42CB83">{{$t('burst.q3.drawn_prize')}}</label>
                            <label v-else>{{$t('burst.q3.drawn_no_prize')}}</label>
                        </template>
                    </el-table-column>
                    <el-table-column
                            :label="$t('burst.q3.rewardMoney')"
                            width="140px">
                        <template slot-scope="scope">
                            <label v-if="scope.row.reward <= 0">- -</label>
                            <label v-else>{{scope.row.reward}}</label>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
        </main>
        <v-footer style="margin-top: 70px"></v-footer>
        <div class="black-wrap" v-show="alertKey">
            <div class="alert-wrap">
                <div class="alert-main">
                    <header class="alert-title">
                        {{$t('burst.alert.title_key')}}
                    </header>
                    <div>{{$t('burst.alert.publicKey')}}</div>
                    <p class="key-p">{{currentBlockData.publicKey}}</p>
                    <div style="margin-top: 30px">{{$t('burst.alert.privateKey')}}</div>
                    <p class="key-p">{{currentBlockData.privateKey}}</p>
                </div>
                <div class="btn-back" v-html="$t('burst.alert.back')" @click="alertKey = false"></div>
            </div>
        </div>
        <div class="black-wrap rules-wrap" v-show="alertRules">
            <div class="alert-wrap">
                <div class="alert-main">
                    <header class="alert-title">
                        {{$t('burst.alert.title_rules')}}
                    </header>
                    <div class="rules-con" v-html="$t('burst.alert.rules_con')"></div>
                </div>
                <div class="btn-back" v-html="$t('burst.alert.back')" @click="alertRules = false"></div>
            </div>
        </div>
    </div>
</template>

<script>
    import VNumber from "../../components/Number/VNumber";
    import VFooter from "../../components/footer/VFooter";
    import {mapState} from 'vuex';

    export default {
        name: "Burst",
        components: {VFooter, VNumber},
        data() {
            return {
                smallReward: 0,
                bigReward: 0,
                blockData: [
                    {
                        time: '2019-07-01 18:30:45:0',
                        blockNum: '#66368543',
                        hash: 'h124e5346llo34234w25orl3452dw6346t6f234f556234tfw43v54yv'
                    },
                    {
                        time: '2019-07-01 18:30:45:0',
                        blockNum: '#66368543',
                        hash: 'h124e5346llo34234w25orl3452dw6346t6f234f556234tfw43v54yv'
                    },
                    {
                        time: '2019-07-01 18:30:45:0',
                        blockNum: '#66368543',
                        hash: 'h124e5346llo34234w25orl3452dw6346t6f234f556234tfw43v54yv'
                    }
                ],
                showTable: 0,
                currentBlockData: {
                    bigRewardHitNumbers: "",
                    eosBlockTime: "",
                    eosFirstBlockNo: 0,
                    eosFirstHashVal: "",
                    eosSecondBlockNo: 0,
                    eosSecondHashVal: "",
                    periodDate: 0,
                    privateKey: "",
                    publicKey: "",
                    smallRewardHitNumbers: ""
                },
                awardData: [],
                orderData: [],
                alertKey: false,
                alertRules: false
            }
        },
        created() {
            this.getHistoryAward();
            if (this.user.username && window.localStorage.getItem('jwt-token')) {
                this.getUserOrder();
            }
        },
        methods: {
            getHashHtml(hashStr, value) {
                if (hashStr) {
                    let arrStr = hashStr.split('');
                    let num = 0;
                    for (let i = arrStr.length - 1; num < value; i--) {
                        if (!isNaN(parseInt(arrStr[i]))) {
                            arrStr[i] = '<label style="color: #42CB83; font-weight: bold">'+arrStr[i]+'</label>';
                            num++;
                        }
                    }
                    return arrStr.join('');
                }
            },
            getHistoryAward() {
                this.$axios.post('/burstBlock/all',{}).then(res => {
                    if (res.data.code === this.errorCode.ok) {
                        this.smallReward = res.data.data.smallReward;
                        this.bigReward = res.data.data.bigReward;
                        this.awardData = res.data.data.burstBlockDataHistory;
                        this.currentBlockData = res.data.data.burstBlockDataToday;
                    }
                })
            },
            getUserOrder() {
                this.$axios.post('/burstBlock/validOrderList',{}).then(res => {
                    if (res.data.code === this.errorCode.ok) {
                        this.orderData = res.data.data;
                    }
                })
            }
        },
        computed: {
            ...mapState({
                user: 'user',
                errorCode: 'errorCode'
            })
        }
    }
</script>

<style lang="less" scoped>
    .burst-wrap {
        .burst-header {
            position: relative;
            padding: 85px 0;
            color: white;
            background: url("../../assets/img/burst-bg.png");
            background-size: 100% 100%;

            .header-main {
                width: 1200px;
                margin: auto;

                h1 {
                    font-size: 36px;
                    font-weight: normal;
                }

                h3 {
                    margin: 10px 0 60px;
                    font-size: 16px;
                }

                .num-title {
                    margin-bottom: 10px;
                    font-size: 22px;
                }

                .num-footer {
                    font-size: 16px;
                    text-align: right;
                }
            }

            .nav-wrap {
                width: 100%;
                position: absolute;
                bottom: -25px;
                text-align: center;

                nav {
                    display: inline-block;
                    width: 350px;
                    height: 50px;
                    line-height: 50px;
                    border-radius: 25px;
                    background: #48D981;
                    font-size: 20px;
                    box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.15);
                    cursor: pointer;

                    &:nth-of-type(2) {
                        margin: 0 75px;
                    }

                    &:nth-of-type(3) {
                        background-image: url("../../assets/img/must-read.png");
                        background-repeat: no-repeat;
                        background-position: right top;
                    }
                }
            }
        }

        main {
            width: 1200px;
            margin: auto;
            padding: 25px;

            .title {
                height: 50px;
                padding: 0 30px;
                margin-top: 70px;
                line-height: 50px;
                background: #F3F3F9;
                font-size: 18px;
                font-weight: bold;
            }

            .text-con {
                margin-top: 10px;
                padding: 0 30px;
                line-height: 40px;
                font-size: 18px;
                color: #A0AAC1;
            }

            .table-wrap {
                position: relative;
                padding: 0 30px;
                margin-top: 60px;
                border: 2px solid #42CB83;
                border-radius: 2px;
                color: #A0AAC1;

                .table-title {
                    position: absolute;
                    width: 460px;
                    height: 40px;
                    line-height: 40px;
                    font-size: 16px;
                    font-weight: bold;
                    color: white;
                    text-align: center;
                    background: #42CB83;
                    border-radius: 2px;
                    left: 50%;
                    top: 0;
                    transform: translate(-50%, -100%);
                }

                .link-wrap {
                    position: absolute;
                    color: #A0AAC1;
                    right: 0;
                    top: -30px;
                }
                .table-tab-wrap {
                    width: 100%;
                    position: absolute;
                    left: 0;
                    top: -40px;
                    text-align: center;
                    .tab {
                        display: inline-block;
                        width: 460px;
                        height: 40px;
                        line-height: 40px;
                        text-align: center;
                        font-size: 16px;
                        border-radius: 2px;
                        cursor: pointer;
                        user-select: none;
                    }
                    .choice {
                        background: #42CB83;
                        color: white;
                    }
                }
            }

            .btn-wrap {
                margin-top: 30px;
                text-align: center;
                .btn {
                    display: inline-block;
                    width: 270px;
                    height: 50px;
                    line-height: 50px;
                    border-radius: 25px;
                    border: 1px solid #42CB83;
                    color: #42CB83;
                    font-size: 16px;
                    text-align: center;
                    cursor: pointer;
                    user-select: none;
                }
            }
        }

        .black-wrap {
            position: fixed;
            width: 100%;
            height: 100%;
            background: rgba(0,0,0,.6);
            left: 0;
            top: 0;
            font-size: 18px;
            .alert-wrap {
                position: absolute;
                border-radius: 20px;
                overflow: hidden;
                left: 50%;
                top: 50%;
                transform: translate(-50%, -50%);
                .alert-main {
                    background: white;
                    padding: 30px 40px;
                    .alert-title {
                        margin-bottom: 50px;
                        text-align: center;
                        font-size: 18px;
                    }
                    .key-p {
                        margin-top: 15px;
                        font-size: 14px;
                        color: #A0AAC1;
                    }
                }
                .btn-back {
                    width: 100%;
                    height: 50px;
                    line-height: 50px;
                    background: #42CB83;
                    text-align: center;
                    color: white;
                    cursor: pointer;
                    font-size: 16px;
                }
            }
        }
        .rules-wrap {
            font-size: 14px;

        }
    }
</style>